import { render } from "./PageHeader.vue?vue&type=template&id=2dd2a7a6&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=ts"
export * from "./PageHeader.vue?vue&type=script&lang=ts"

import "./PageHeader.vue?vue&type=style&index=0&id=2dd2a7a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2dd2a7a6"

export default script